export const SET_ENHANCED_MODAL_OPEN = 'SET_ENHANCED_MODAL_OPEN';

export const setEnhancedModalOpen = (flag) => ({
  type: SET_ENHANCED_MODAL_OPEN,
  payload: {
    flag,
  },
});
